export const steps = {
  welcome: {
    id: 1,
    label: 'Welcome',
    intlKey: 'wizard.welcome',
    completed: false,
    active: true,
    path: '/welcome',
    next: '/level',
    allowedPaths: ['', '/level']
  },
  level: {
    id: 2,
    label: 'Level selection',
    intlKey: 'wizard.level_selection',
    completed: false,
    active: true,
    path: '/level',
    next: '/contacts',
    allowedPaths: ['/welcome', '/contacts']
  },
  contacts: {
    id: 3,
    label: 'Contacts',
    intlKey: 'wizard.contacts',
    completed: false,
    active: true,
    path: '/contacts',
    next: '/details',
    allowedPaths: ['/level', '/details']
  },
  details: {
    id: 4,
    label: 'Your details',
    intlKey: 'wizard.your_details',
    completed: false,
    active: true,
    path: '/details',
    next: '/profile',
    allowedPaths: ['/profile', '/parent', '/contacts']
  },
  parent: {
    id: 5,
    label: 'Parent consent',
    intlKey: 'wizard.parent_consent',
    completed: false,
    active: false,
    path: '/parent',
    next: '/profile',
    allowedPaths: ['/profile', '/details']
  },
  profile: {
    id: 6,
    label: 'Profile question',
    intlKey: 'wizard.profile',
    completed: false,
    active: true,
    path: '/profile',
    next: '/payment',
    allowedPaths: ['/details', '/parent', '/payment', '/privacy-policy']
  },
  payment: {
    id: 7,
    label: 'Payment',
    intlKey: 'wizard.payment',
    completed: false,
    active: true,
    path: '/payment',
    next: '/privacy-policy',
    allowedPaths: ['/profile', '/privacy-policy']
  },
  privacyPolicy: {
    id: 8,
    label: 'Privacy Policy',
    intlKey: 'wizard.privacy_policy',
    completed: false,
    active: true,
    path: '/privacy-policy',
    next: '/success',
    allowedPaths: ['/payment', '/success', '//mpg-init/*', '//paypal-init/*', '//gp-init/*', '//gp-wp-init/*']
  }
}

export const rootPath = '/register/next-level'

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]

  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath =>
      allowedPath.startsWith('//')
        ? allowedPath.substring(1)
        : rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
